import { render, staticRenderFns } from "./WorkflowStatusDisplay.vue?vue&type=template&id=1b268b88&"
import script from "./WorkflowStatusDisplay.vue?vue&type=script&lang=ts&"
export * from "./WorkflowStatusDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports